



































import {
    Component, Vue, Model, Prop,
} from 'vue-property-decorator';
import moment, { Moment } from 'moment';

@Component
export default class DatePicker extends Vue {
    @Model('input') public value!: Date;

    @Prop({ default: 'Date' }) public label!: string;
    @Prop({ default: null }) public min!: string;

    public dateMenu = false;

    public onInput(event: any) {
        this.$emit('input', event);
        this.dateMenu = false;
    }

    public onClickClear() {
        this.$emit('input', null);
    }

    get computedDateFormatted() {
        return this.value ? moment(this.value).format('MMMM Do YYYY') : '';
    }
}
